import { Link, useNavigate } from 'react-router-dom';
import galleryimg from '../assets/images/gallery.png';
import searchicon from '../assets/images/search.png';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearMessage } from '../slices/messages';
import { allJob } from '../slices/jobs';
import Pagination from './dt/Pagination';
import { useTranslation } from 'react-i18next';

const Jobs = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { alljobs } = useSelector((state) => state.jobs);
    const { user } = useSelector((state) => state.auth);

    const { t } = useTranslation();
    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';
    const [activeLang, setActiveLang] = useState(currentLang);

    const [currentPage, setCurrentPage] = useState(1);
    const [defaultSort, setSort] = useState({ 'sort_column': 'created_at', 'sort_type': 'desc' });
    const [search, setSearch] = useState("");

    let PageSize = 10;

    const changePageSize = (pageNumber) => {
        setSort({ 'sort_column': 'created_at', 'sort_type': 'desc' });
        setCurrentPage(pageNumber);
    }

    useEffect(() => {
        if(user && user.approve == "N") {
            navigate('/profile');
        }

        dispatch(clearMessage());

        let tmpVar = {
            page: currentPage,
            sort: defaultSort,
            activeLang: activeLang,
            search: search,
            status: '1'
        };

        dispatch(allJob(tmpVar));
    }, [defaultSort, currentPage, search]);

    return (
        <div className="container">
            <section className="mt-5 pt-5 gallery">
                <div className="row">
                    <div className='col-md-6'>
                        <div className='section-title' id='heading_title'>
                            <h1><span className='font-color-1'>{t('all_jobs')}</span></h1>
                            <p className='mb-0'>{t('approved_job')}</p>
                        </div>
                    </div>
                    <div className='col-xs-12 col-md-6 table-search-area single-search mt-5'>
                        <div className='table-search'>
                            <input type='search' className='form-control' placeholder={t('search_here')} onChange={e => setSearch(e.target.value)} />
                            <img src={searchicon} />
                        </div>
                    </div>

                    <div className='col-md-12 mt-2-5'>
                        <div className='table-area bg-2 font-color'>
                            <div className='table-responsive'>
                                <table className='table '>
                                    <thead>
                                        <tr>
                                            <th>{t('title')}</th>
                                            <th>{t('contact_no')}</th>
                                            <th>{t('qualification')}</th>
                                            <th>{t('location')}</th>
                                            <th>{t('minimum_salary')}</th>
                                            <th>{t('maximum_salary')}</th>
                                            <th class="create_at"> {t('createdAt')}</th>
                                            <th>{t('action')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            alljobs?.res.map((item, index) => {
                                                return (
                                                    <tr key={item.id}>
                                                        <td>{item.title}</td>
                                                        <td>{item.contact_no}</td>
                                                        <td>{item.qualification}</td>
                                                        <td>{item.location}</td>
                                                        <td>{item.min_salary}</td>
                                                        <td>{item.max_salary}</td>
                                                        <td >{item.created_at}</td>
                                                        <td>
                                                            <Link to={`/job/view/${item.id}`} className='btn btn-primary btn-sm'><i className='fa fa-eye'></i></Link>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12'>
                        <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            totalCount={alljobs ? alljobs.total : 1}
                            pageSize={PageSize}
                            onPageChange={page => changePageSize(page)}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}
export default Jobs;